export class ProcessFilter {
    pageSize?: number;
    from?: string;
    to?: string;
    status?: string;
    offset?: number;
    limit?: number;
}
